import React from 'react';
import { IconFilter } from '@tabler/icons-react';
import './BoardClickUpFilterChip.css';
import './BoardToolbarSearchFilters.css';

/** Botão "Filtro" estilo ClickUp — toolbar Board. */
export function BoardToolbarFilterClickUpButton({
  onClick,
  isOpen = false,
  activeCount = 0,
  disabled = false,
  tourHighlight = false,
}) {
  const hasFilters = activeCount > 0;

  return (
    <div className="board-clickup-icon-btn-anchor">
      <button
        type="button"
        className={[
          'board-clickup-filter-chip',
          'board-clickup-filter-chip--filter',
          isOpen ? 'is-open' : '',
          hasFilters ? 'has-filters' : '',
          tourHighlight ? 'is-tour-highlight' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={onClick}
        disabled={disabled}
        aria-label="Abrir filtros"
        aria-expanded={isOpen}
        data-tour="bsf-trigger"
      >
        <span className="board-clickup-filter-chip-icon" aria-hidden="true">
          <IconFilter size={13} stroke={1.75} />
        </span>
        <span className="board-clickup-filter-chip-text">
          <span className="board-clickup-filter-chip-label">Filtro</span>
        </span>
        {hasFilters ? (
          <span className="column-filter-badge fechamento-nav-badge ec-av-kanban-group-pill-badge">
            {activeCount > 99 ? '99+' : activeCount}
          </span>
        ) : null}
      </button>
    </div>
  );
}
